<template>
  <v-card class="item" color="white" :to="to" flat>
    <img
      @error="onError"
      class="d-block rounded-lg item-img"
      :src="files + img + '?resize=1&w=360'"
      :alt="title"
    />

    <div class="pt-2 pb-4 px-3 item-content">
      <div
        class="
          grey--text
          text--darken-4 text-body-1 text-md-h6
          font-weight-medium
          item-title
        "
      >
        {{ title }}
      </div>

      <div
        class="
          grey--text
          text--darken-2 text-body-2
          font-weight-regular
          mt-1
          item-text
        "
        v-html="parsedText"
      ></div>
    </div>
  </v-card>
</template>

<script>
import DefaultImg from "../../assets/img/default-img.png";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    parsedText() {
      return this.text.replace(/<\/?[^>]+(>|$)/g, "");
    },
  },
  methods: {
    onError(e) {
      e.target.src = DefaultImg;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    aspect-ratio: 340 / 200;
    object-fit: cover;
    width: 100%;
  }

  &-title {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &-text {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
